import React from 'react';
import { Card, CardContent } from '../../../components/ui/card';
import { fmtDate } from '../shared';

const Info = ({ label, value, testId }) => (
  <div className="min-w-0" data-testid={testId}>
    <p className="text-[10px] uppercase tracking-wide text-slate-400 font-semibold">{label}</p>
    <p className="text-sm font-medium text-slate-800 truncate" title={typeof value === 'string' ? value : undefined}>{value || '—'}</p>
  </div>
);

// Frise chronologique : séances planifiées, réalisées en indigo, trait rouge = date du bilan
export const Frise = ({ frise }) => {
  const d0 = new Date(frise.date_debut).getTime();
  const d1 = new Date(frise.date_fin).getTime();
  const span = Math.max(d1 - d0, 1);
  const px = (iso) => `${Math.min(Math.max((new Date(iso).getTime() - d0) / span, 0), 1) * 100}%`;
  const realisees = frise.seances.filter(s => s.realisee).length;
  return (
    <div className="pt-6 pb-5 px-2" data-testid="bilan-frise">
      <div className="relative h-8">
        <div className="absolute left-0 right-0 top-1/2 h-1 -translate-y-1/2 bg-slate-200 rounded" />
        {frise.seances.map(s => (
          <div key={s.date} className={`absolute top-1/2 -translate-y-1/2 -translate-x-1/2 w-1.5 h-6 rounded-sm ${s.realisee ? (s.validee ? 'bg-indigo-600' : 'bg-indigo-400') : 'bg-white border border-slate-300'}`} style={{ left: px(s.date) }} title={`${fmtDate(s.date)} — ${s.realisee ? (s.validee ? 'réalisée, présences validées' : 'réalisée') : 'planifiée'}`} />
        ))}
        <div className="absolute -top-2 -bottom-2 w-0.5 bg-red-500 -translate-x-1/2" style={{ left: px(frise.date_bilan) }} data-testid="bilan-frise-marker">
          <span className="absolute -top-5 left-1/2 -translate-x-1/2 whitespace-nowrap text-[10px] font-semibold text-red-600">Bilan du {fmtDate(frise.date_bilan)}</span>
        </div>
      </div>
      <div className="flex justify-between text-[11px] text-slate-500 mt-2">
        <span>{fmtDate(frise.date_debut)}</span>
        <span>{realisees} séance(s) réalisée(s) / {frise.seances.length} planifiée(s)</span>
        <span>{fmtDate(frise.date_fin)}</span>
      </div>
    </div>
  );
};

export const BilanEntete = ({ data }) => {
  const { dossier: d, kpis: k, bilan: b } = data;
  return (
    <Card className="border-0 shadow-sm" data-testid="bilan-entete">
      <CardContent className="p-4 space-y-3">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          <Info label="Code AF" value={d.code} testId="bilan-info-code" />
          <Info label="Intitulé de l'action" value={d.intitule} />
          <Info label="Programme de formation" value={`${d.formation_titre}${d.formation_code ? ` (${d.formation_code})` : ''}`} />
          <Info label="Client" value={d.client} />
          <Info label="Durée" value={`${d.duree_totale_heures || k.heures_prevues} h · ${d.nb_seances_total} séance(s)`} />
          <Info label="Dates" value={`${fmtDate(d.date_debut)} → ${fmtDate(d.date_fin)}`} />
          <Info label="Candidats" value={`${k.effectif} inscrit(s) · ${k.actifs} actif(s) · ${k.abandons} abandon(s)`} testId="bilan-info-candidats" />
          <Info label="Formateur(s)" value={(d.formateurs || []).join(', ')} />
          <Info label="Lieu" value={d.lieu} />
          <Info label="Référent" value={d.referent} />
          <Info label="Bilan rédigé par" value={`${b.auteur || '—'} le ${fmtDate(b.date_bilan)}`} />
          <Info label="Type" value={b.type === 'final' ? 'Bilan final' : 'Bilan intermédiaire'} testId="bilan-info-type" />
        </div>
        {d.objectifs?.length > 0 && <div className="text-xs text-slate-600"><span className="font-semibold text-slate-500">Objectifs :</span> {d.objectifs.join(' · ')}</div>}
        <Frise frise={data.frise} />
      </CardContent>
    </Card>
  );
};
